import selectReplyOption from '../actions/selectReplyOption';
import ReplyOptionState from '../store/schema/ReplyOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

const REPLY_KEY = 'Reply';
const REPLY_ALL_KEY = 'ReplyAll';

export interface ReplyFullProps {
    optionStore?: ReplyOptionState;
    userOptions?: UserOptionsType;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class ReplyFull extends React.Component<ReplyFullProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;

        let isReplyAllDefault = getFallbackValueIfNull(
            optionStore.replyAllByDefault,
            userOptions.IsReplyAllTheDefaultResponse
        );

        let selectedKey = isReplyAllDefault ? REPLY_ALL_KEY : REPLY_KEY;

        let choices = [
            {
                key: REPLY_KEY,
                text: strings.options_mail_Reply,
            },
            {
                key: REPLY_ALL_KEY,
                text: strings.options_mail_ReplyAll,
            },
        ];

        return (
            <ChoiceGroup
                selectedKey={selectedKey}
                options={choices}
                onChange={this.onChange}
                label={strings.options_mail_ReplyOptionLabel}
            />
        );
    }

    private onChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectReplyOption(option.key === REPLY_ALL_KEY);
    };
}
